const sipsic = {
    ObtenerCuentas: "SIPSIC/ObtenerCuentas",    
    AltaPsicologo: "SIPSIC/AltaPsicologo",   
    ObtenerPsicologos: "SIPSIC/ObtenerPsicologos",   
    ObtenerPsicologo: "SIPSIC/ObtenerPsicologo",
    EditarPsicologo: "SIPSIC/EditarPsicologo",
    DesactivarPsicologo: "SIPSIC/DesactivarPsicologo",
    RelacionarTiposTramitesPJ: "SIPSIC/RelacionarTiposTramitesPJ",
    BuscarExpediente: "SIPSIC/BuscarExpediente",
    GuardarDictamen: "SIPSIC/GuardarDictamen",
    GetDictamenes: "SIPSIC/GetDictamenes",
    GetMisDictamenes: "SIPSIC/GetMisDictamenes",
    GuardarCitaDictamen: "SIPSIC/GuardarCitaDictamen",
    GetCitasAgenda: "SIPSIC/GetCitasAgenda",
    CambiarEstatusCita: "SIPSIC/CambiarEstatusCita",
    FinalizarDictamen: "SIPSIC/FinalizarDictamen",
    GetMisCitas: "SIPSIC/GetMisCitas",
    ReagendarCita: "SIPSIC/ReagendarCita",
    GetBloquesAgenda: "SIPSIC/GetBloquesAgenda",
    FinalizarDictamen: "SIPSIC/FinalizarDictamen",
    AsignarPsicologo: "SIPSIC/AsignarPsicologo",
    GetPersonasExpediente: "SIPSIC/GetPersonasExpediente",
    GenerarDocumentoAnexo: "SIPSIC/GenerarDocumentoAnexo",
    ObtenerExpedienteElectronico: "SIPSIC/ObtenerExpedienteElectronico",
    ObtenerCaratulaExpedienteElectronico: "SIPSIC/ObtenerCaratulaExpedienteElectronico",
    GetDatosParaExpedienteElectronico: "SIPSIC/GetDatosParaExpedienteElectronico",
    AgregarRutaOficio: "SIPSIC/AgregarRutaOficio",
    DesactivarDictamen: "SIPSIC/DesactivarDictamen",
    DetenerDictamen: "SIPSIC/DetenerDictamen",
    GetDictamen: "SIPSIC/GetDictamen",
    GetCitaDeDictamen: "SIPSIC/GetCitaDeDictamen",
    GetAnexosDictamen: "SIPSIC/GetAnexosDictamen",
    ResubirAnexoDeDictamen: "SIPSIC/ResubirAnexoDeDictamen"
}
export default sipsic;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIPSIC/funcion/sipsic.js
// module id = null
// module chunks = 